import React from 'react';
import { Box, Typography } from '@material-ui/core';
import NextBtn from "../../partial/NextBtn";
import RouterLinkLargeBtn from "../../partial/RouterLinkLargeBtn";
import TestDuration from "../../partial/TestDuration";
import StyleScoreView from "./styles/StyleScoreView";
import Loading from "../../helper/Loading";
import { objIsEmpty } from "../../../helpers/objIsEmpty";
import withUrlParams from "../../HOC/withUrlParams";
import i18n from 'i18next';
import { upperFirst } from "../../../helpers/upperFirst";
import { useRecoilValue } from "recoil";
import { isOnlineState, tokenInfoState } from "../../../states/states";
import CustomSweetAlert from "../../helper/CustomSweetAlert";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const ScoreView = (props) => {
    const classes = StyleScoreView();
    const { testResult, submitSuccess, testCode, lessonCode, currCode, uuid, tryTime } = props;
    const isOnline = useRecoilValue(isOnlineState);
    const tokenInfo = useRecoilValue(tokenInfoState);
    const back = () => {
        isOnline && history.push(`/my-courses?uuid=${uuid}`)
    };
    let history = useHistory();
    let currentUrlPage = history.location.pathname;


    if (submitSuccess && objIsEmpty(testResult)) {
        return <h6 className={classes.noResult}><p>{i18n.t('submit_successful')}.</p></h6>;
    }
    let testType = testCode ? testResult.testTypeId : testResult.lessonTypeId;
    if (testType === 1 || testType === 2 || testType === 3) {
        return (
            <React.Fragment>
                <div className={classes.scoreView}>
                    <div className={classes.imageScoreView}>
                        <img src={
                            Math.round(((testResult.numberOfCorrectAnswers) / testResult.numberOfQuestions) * 100) > 50 ?
                                require('../../../assets/images/test_duocdiemcao.png') :
                                require('../../../assets/images/emotion_01.png')
                        } alt="Test" className="center" />

                    </div>

                    <div className={classes.contentScoreView}>
                        <Typography variant="h2" align="center" className={classes.testName}>
                            {
                                Math.round(((testResult.numberOfCorrectAnswers) / testResult.numberOfQuestions) * 100) > 50 ?
                                    <b>{upperFirst(i18n.t('congratulations'))}</b> :
                                    <b>{upperFirst(i18n.t('sorry'))}</b>
                            }
                        </Typography>
                        <Typography variant="h6" align="left">
                            <b>{upperFirst(i18n.t('user_name'))}:&nbsp;
                                {tokenInfo.fullName ? tokenInfo.fullName : ""}</b>
                        </Typography>
                        <Typography variant="h6" align="left">
                            <b>{upperFirst(i18n.t('phone_number'))}:&nbsp;
                                {tokenInfo.phone ? tokenInfo.phone : ""}</b>
                        </Typography>
                        <Typography variant="h6" align="left">
                            <b>{upperFirst(i18n.t('attempt'))}:&nbsp;
                                {testResult.tryTimes ? testResult.tryTimes : ""}</b>
                        </Typography>
                        {(testResult.viewScore == null || testResult.viewScore == 1)
                            ?
                            <Typography variant="h6" align="left">
                                <b>{upperFirst(i18n.t('result'))}
                                    {testType === 1 ? ` ${i18n.t('test')} ` :
                                        testType === 2 ? (testCode ? ` ${i18n.t('practice')} ` : ` ${i18n.t('practice_lesson')}: `) :
                                            testType === 3 ? ` ${i18n.t('exam')} ` : ""
                                    }
                                    {testResult.numberOfCorrectAnswers}/{testResult.numberOfQuestions}&nbsp;
                                    ({Math.round(((testResult.numberOfCorrectAnswers) / testResult.numberOfQuestions) * 100)}%)</b>
                            </Typography>
                            :
                            ""
                        }
                        <TestDuration startTime={testResult.studentStartTime}
                            endTime={testResult.studentLastSubmitTime}
                            align={"left"} />
                    </div>
                    {currentUrlPage.search('result') === -1
                        ? <div className="button-show-result">
                            {testCode ?
                                <RouterLinkLargeBtn to={`/result?test_code=${testCode}&uuid=${uuid}`}>
                                    {i18n.t('see_result')}</RouterLinkLargeBtn>
                                :
                                <RouterLinkLargeBtn to={`/result?lesson_code=${lessonCode}&uuid=${uuid}&curr_code=${currCode}`}>
                                    {i18n.t('see_result')}</RouterLinkLargeBtn>}
                        </div> : ""
                    }
                    {/* check so lan thi lai */}
                    {testResult.tryTimes > 1 ? (
                        <NextBtn
                            onClick={() => {
                                window.location.reload();
                            }}>
                            {testType === 1 ? i18n.t('retake_test') :
                                testType === 2 ? (testCode ? i18n.t('continue_practice') : i18n.t('continue_learning')) :
                                    testType === 3 ? i18n.t('retest') : ""
                            }
                        </NextBtn>
                    ) : ""}
                   
                </div>
            </React.Fragment>
        );
    } else if (testType === 4) {
        return (
            <div className="list-test">
                <img src={require('../../../assets/images/end_khaosat_binhchon.png')} alt="Test"
                    className="center" />
                {testResult.imageUrl ? <img
                    style={{ position: 'absolute', left: '10%', top: '50%', width: '80%' }}
                    src={testResult.imageUrl} alt="Test" className="center" /> : ""}
                <div className="area-button button-back-lesson" onClick={back}>
                    <NextBtn><ArrowBackIosIcon /> {i18n.t('back_lesson')}</NextBtn>
                </div>
            </div>
        )
    } else if (testType === 5 || testType === 6 || testType === 7 || testType === 8 || testType === 9) {
        return (
            <div className="list-test" style={{ textAlign: 'center' }}><img
                src={require('../../../assets/images/end_khaosat_binhchon.png')}
                alt="Test" className="center" />
                <h2>
                    {testResult.message}
                </h2>
                <div className="area-button button-back-lesson" onClick={back}>
                    <NextBtn><ArrowBackIosIcon /> {i18n.t('back_lesson')}</NextBtn>
                </div>
            </div>
        )
    }

    if (!isOnline) {
        return <CustomSweetAlert show={true} text={i18n.t('NO_NETWORK')} showConfirm={false} />;
    }

    return <Loading />;
};

export default withUrlParams(ScoreView);
